import styled from 'styled-components';

export const Card = styled.div`
  ${(props) =>
    props.height &&
    `
    height: ${props.height};
  `};

  ${(props) =>
    props.overflow &&
    `
    overflow-y: ${props.overflow};
    overflow-x: hidden;
  `}

  ${(props) =>
    props.marginLeft &&
    `
    margin-left: ${props.marginLeft}px;
  `}

  ${(props) =>
    props.marginRight &&
    `
    margin-right: ${props.marginRight}px;
  `}

  padding: ${(props) => (props.removePadding ? '0px' : props.padding || '16px')};

  position: relative;
  border-radius: 4px;
  background-color: #fff;
  box-shadow:
    ${(props) =>
      props.removeShadow
        ? undefined
        : props.largeShadow
        ? `0 13px 27px -5px rgba(50, 50, 93, 0.16), 0 8px 16px -8px rgba(0, 0, 0, 0.11)`
        : `0px 1px 3px 0px rgba(224, 224, 224, 0.2),
              0px 1px 1px 0px rgba(0, 0, 0, 0.14),
              0px 2px 1px -1px rgba(217, 217, 217, 0.12)`};

  flex: ${(props) => (props.flex !== undefined ? props.flex : '')};
`;

export const CardFooter = styled(Card)``;

export const TitleText = styled.h1`
  font-family: roboto;
  font-weight: 400;
  display: flex;
  align-items: center;
  margin: 0px;
  color: ${(props) => props.color};
  font-size: 1.6em;
`;

export const SubTitleText = styled.h2`
  font-family: roboto;

  font-weight: ${(props) => (props.bold ? 400 : 300)};
  display: inline-flex;
  font-size: ${(props) => props.size || `1.5em`};
  color: ${(props) => props.color || '#00000091'};

  align-items: center;
  margin: 0px;

  position: relative;
`;

export const NoticeText = styled.div`
  font-family: roboto;

  font-size: ${(props) => props.size || `1em`};
  color: ${(props) => props.color || '#f7f7f7'};

  text-align: center;
  margin: 0 auto;

  position: relative;
  padding: 10px 15px;

  border-radius: 4px;
  background-color: rgb(0,118,190);
`;

export const InkBar = styled.div`
  width: 2px;
  left: 0px;
  top: 0px;
  height: 100%;
  position: absolute;
  background-color: ${(props) => props.theme.lightGrey};
`;
